// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__3FhIv","is-bidi":"Icon_is-bidi__1Bqb-"};